module.exports = __webpack_public_path__ + "img/lingjunqiye.3ce6ec60.jpg";